module.exports = require("core-js-pure/stable/object/assign");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/assign.js
// module id = 603
// module chunks = 0